module.exports = __webpack_public_path__ + "img/로열가드.6ebfff05.png";